<template>
  <p v-if="error" class="error-message">{{ error }}</p>
  <div class="login">
    <div class="form-container">
      <h1>Einloggen</h1>
      <form @submit.prevent="submitRequest">
        <label for="email">Username/Email</label>
        <input type="text" id="email" v-model="email" placeholder="Username/Email eingeben" required />
        
        <label for="password">Passwort</label>
        <input type="password" id="password" v-model="password" placeholder="Passwort eingeben" required />
        
        <button type="submit">Einloggen</button>
      </form>
    </div>
  </div>
</template>


<script>
import { login } from "@/composables/api";
import router from "@/router";
import { ref } from "vue";

export default {
  components: { },
  setup() {
    const email = ref("");
    const password = ref("");
    const error = ref(null);

    async function submitRequest() {
      const { success, message } = await login(email.value, password.value);
      if(success) {
        router.push("/dashboard")
      }else {
        error.value = message
      }
    }

    return { email, password, submitRequest, error };
  }
};
</script>

<style>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #6b73ff, #000dff);
  color: white;
  font-family: Arial, sans-serif;
  position: relative; /* Ensure the message stays inside the container */
}

.form-container {
  background: white;
  color: #333;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

h1 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

label {
  text-align: left;
  font-weight: bold;
  font-size: 0.9rem;
}

input {
  padding: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

input:focus {
  border-color: #6b73ff;
  outline: none;
  box-shadow: 0 0 5px rgba(107, 115, 255, 0.5);
}

button {
  padding: 0.8rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  color: white;
  background-color: #6b73ff;
  cursor: pointer;
}

button:hover {
  background-color: #000dff;
}

.error-message {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff4d4f;
  color: white;
  padding: 1rem;
  border-radius: 20px;
  font-size: 1rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

</style>
